module.exports = __webpack_public_path__ + "static/img/nanoscience_2.21eaad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/nanoscience_2.png
// module id = uO8x
// module chunks = 6